import { render, staticRenderFns } from "./ScreeningReport.vue?vue&type=template&id=5f320e26&scoped=true"
import script from "./ScreeningReport.vue?vue&type=script&lang=js"
export * from "./ScreeningReport.vue?vue&type=script&lang=js"
import style0 from "./ScreeningReport.vue?vue&type=style&index=0&id=5f320e26&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f320e26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f320e26')) {
      api.createRecord('5f320e26', component.options)
    } else {
      api.reload('5f320e26', component.options)
    }
    module.hot.accept("./ScreeningReport.vue?vue&type=template&id=5f320e26&scoped=true", function () {
      api.rerender('5f320e26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screening/screeningDataInfo/ScreeningReport.vue"
export default component.exports